import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../common/SpinnerComponentUI'
import LoanPropertyUpdateModalSF from './LoanPropertyUpdateModalSF'
import './LoanPropertyList.css'

const SystemGeneratedPropertyListUI = ({ context, propertyList, errorList, loan,
  // modes
  category, categoryLabel,
  // event handlers
  onRefreshClick,
}) =>
  <CardUI className='su_l_props g_m_top_100' title={categoryLabel} noUnderline={true}>
    {
      !propertyList &&
      <SpinnerComponentUI />
    }

    <LRTableBodyUI>
      {
        propertyList && propertyList.filter(p => p.category === category).map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} i={i} property={property} />}
            right={<RowRightUI property={property} />}
          />
        )
      }
    </LRTableBodyUI>

  </CardUI>

const RowLeftUI = ({ context, i, property }) =>
  <div className='g_flex_h g_flex_left'>
    {
      property.propertyCode !== 'term_sheet_special_terms' &&
      <>
        <span className='g_m_right_50'>
          {i + 1}.
        </span>
        <span>
          {property.propertyName}<br />
          {
            property.hint &&
            <span className='g_muted g_small'>{property.hint}</span>
          }
        </span>
      </>
    }
  </div>

const RowRightUI = ({ property }) =>
  <div className={`g_flex_h g_m_left_100 g_flex_top g_flex_right
      ${property.propertyCode != 'term_sheet_special_terms' ? 'right1' : ''}`}>
    {
      property.propertyType !== 'boolean_' &&
      <span className='wrap' dangerouslySetInnerHTML={{ __html: property.propertyValue || property.defaultValue }} />
    }
    {
      property.propertyType === 'boolean_' &&
      <span>{property.propertyValue != null ? (property.propertyValue === '1' ? 'Yes' : 'No') :
        (property.defaultValue === '1' ? 'Yes' : 'No')}</span>
    }
  </div>

export default SystemGeneratedPropertyListUI
